"use client";

import { Package, Sprout } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function FeaturesGrid() {
  const features = [{
    id: 1,
    iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-01.png",
    title: "Animal Records",
    description: "One profile per animal across every species you raise. Tag, breed, sex, DOB, registration number, weight history, FAMACHA scores, vaccinations with lot, dose, and withholding window. When you sell, one tap builds a buyer packet PDF — or transfers the whole record straight to the buyer's BarnDesk farm."
  }, {
    id: 2,
    icon: Sprout,
    title: "Breeding & Pedigrees",
    description: "Natural cover or AI — with straw inventory that counts down as you use it, technician and sire source on every service, and due dates that set themselves from your species' gestation. Every animal shows a 3-generation pedigree with registration numbers, and the sire performance report ranks every buck, bull, and straw by conception rate and how the offspring actually grow."
  }, {
    id: 3,
    iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-02.png",
    title: "Chores & Tasks",
    description: "Recurring chores, treatment follow-ups, hoof trims, equipment service intervals. Log a birth and BarnDesk offers your kid-care schedule — CD&T, banding, weaning checks — pre-set to what YOUR farm does, never somebody else's checklist. Mark it done from the pasture and the next instance schedules itself."
  }, {
    id: 4,
    iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-06.png",
    title: "Tax & USDA Paperwork",
    description: "Snap the receipt. BarnDesk auto-sorts it into IRS Schedule F line items: feed, seed, fertilizer, vet, fuel, repairs, custom hire. Livestock sales get the correct treatment — raised, purchased resale, or breeding stock. And when USDA disaster programs open, forms like LFP start pre-filled from records you already keep."
  }, {
    id: 5,
    icon: Package,
    title: "Inventory",
    description: "Feed, minerals, medications, and supplies — right down to the straws in the semen tank. Know what's on hand, what's running low, and what needs reordered before you run out."
  }, {
    id: 6,
    iconImage: "https://thebarndesk.com/wp-content/uploads/2026/05/Feature-icons-04.png",
    title: "Equipment Care",
    description: "Hours, service dates, repairs, and maintenance notes for every tractor, UTV, implement, and trailer. The records that turn a breakdown into a 30-minute fix instead of a 3-hour mystery."
  }];
  return <section data-section-id="253919" id="features-grid" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4">
            Everything BarnDesk tracks
          </h2>
          <p className="font-sans text-base md:text-lg text-foreground/80 max-w-2xl mx-auto">
            Every animal, every breeding, every receipt, every repair. Captured in the field, not at the kitchen table after dark.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.id} data-index={i}>
                <Card className="h-full flex flex-col border border-border rounded-lg shadow-md bg-card">
                  <CardHeader className="flex flex-col items-center text-center gap-4">
                    <div className="flex items-center justify-center w-16 h-16 rounded-lg" style={{
                  border: "2px solid var(--primary)"
                }}>
                      {feature.iconImage ? <img src={feature.iconImage} alt={feature.title} className="w-10 h-10 object-contain" /> : Icon ? <Icon size={28} style={{
                    color: "var(--primary)"
                  }} strokeWidth={1.5} /> : null}
                    </div>
                    <CardTitle className="font-default text-xl font-bold text-primary">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="font-sans text-sm text-foreground/70 leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}